import styled from "styled-components";

export const LoadingBigContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

export const LoadingContainer = styled.div`
  background: #000;
  z-index: 999999999999;
  width: 100%;
  height: 100vh;
  position: relative;
  opacity: 0.2;
`;
export const LoadingContainerFit = styled.div`
  background: #000;
  z-index: 999999999999;
  width: 100%;
  height: 100%;
  position: relative;
  opacity: 0.2;
`;
export const LoadingBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
